(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-trust"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const openVelaro = () => {
      if (typeof window.Velaro === 'function') {
        try {
          window.Velaro('expand');
          return;
        } catch (error) {}
      }

      let tries = 0;
      const timer = setInterval(() => {
        tries += 1;
        if (typeof window.Velaro === 'function') {
          clearInterval(timer);
          try {
            window.Velaro('expand');
          } catch (error) {}
        } else if (tries > 100) {
          clearInterval(timer);
        }
      }, 100);
    };

    const cleanNumber = (value) => Number(String(value || '0').replace(/[^0-9.-]/g, '')) || 0;

    const animateNumber = (metric, duration) => {
      const number = metric.querySelector('[data-trust-number]');
      if (!number) return;

      const target = cleanNumber(number.dataset.target);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        number.textContent = target.toLocaleString('en-US');
        return;
      }

      if (typeof window.Odometer === 'function') {
        if (!number.odometer) {
          number.textContent = '0';
          number.odometer = new Odometer({
            el: number,
            value: 0,
            format: '(,ddd)',
            theme: 'default',
            duration: duration,
          });
        } else {
          number.odometer.update(0);
        }

        window.setTimeout(() => number.odometer.update(target), 80);
        return;
      }

      const start = performance.now();
      const tick = (time) => {
        const progress = Math.min((time - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        number.textContent = Math.round(target * eased).toLocaleString('en-US');

        if (progress < 1) {
          requestAnimationFrame(tick);
        }
      };

      number.textContent = '0';
      requestAnimationFrame(tick);
    };

    const initBar = (bar) => {
      if (!bar || bar.dataset.trustAnnouncementReady === 'true') return;
      bar.dataset.trustAnnouncementReady = 'true';

      bar.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-velaro-chat-trigger]');
        if (!trigger) return;

        event.preventDefault();
        event.stopPropagation();
        openVelaro();
      }, true);

      const metrics = Array.from(bar.querySelectorAll('[data-trust-metric]'));
      if (metrics.length === 0) return;

      const delay = Number(bar.dataset.rotateDelay) || 4000;
      const duration = Number(bar.dataset.odometerDuration) || 1400;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let activeIndex = Math.max(metrics.findIndex((metric) => metric.classList.contains('is-active')), 0);

      metrics.forEach((metric, index) => {
        metric.classList.toggle('is-active', index === activeIndex);
      });

      animateNumber(metrics[activeIndex], duration);

      if (metrics.length < 2 || reduceMotion) return;

      setInterval(() => {
        const current = metrics[activeIndex];
        activeIndex = (activeIndex + 1) % metrics.length;
        const next = metrics[activeIndex];

        current.classList.remove('is-active');
        current.classList.add('is-leaving');
        next.classList.add('is-active');
        animateNumber(next, duration);

        setTimeout(() => current.classList.remove('is-leaving'), 550);
      }, delay);
    };

    const init = (root = document) => {
      root.querySelectorAll('[data-trust-announcement]').forEach(initBar);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerInner = document.querySelector('.header');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
		
		if (this.headerIsAlwaysSticky) this.reveal; 
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
